import { FC } from 'react';
import { Heading, Types, Accordion } from '@marriott/mi-ui-library';
import { EventTrackingData, EventTrackingProps } from './EventTracking.types';
import { StyledEventTracking } from './EventTracking.styles';
import { EventBookingDetails } from '../../../rooming-list/PlannerNewEvent/EventBookingDetails';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EventTracking: FC<EventTrackingProps> = (props: any) => {
  const { heading, bookingStatsLabels, groupRatesLabels, eventTrackingData } = props;
  return eventTrackingData?.length > 0 ? (
    <StyledEventTracking data-testid="groups-EventTracking" data-component-name="o-groups-EventTracking">
      <div className="m-0 row align-items-center justify-content-between">
        <Heading
          variation={Types.headingType.title}
          element={Types.tags.h1}
          titleText={heading}
          fontSize={Types.size.medium}
          customClass="my-5"
        />
      </div>
      <div>
        {eventTrackingData.map(
          (eventDetails: EventTrackingData) =>
            eventDetails && (
              <Accordion id={`accordion-${eventDetails?.propertyIndex}`} headerChildren={eventDetails?.propertyName}>
                <EventBookingDetails
                  bookingStatsLabels={bookingStatsLabels}
                  bookingStatsData={eventDetails?.bookingStatsData}
                  groupRatesLabels={groupRatesLabels}
                  groupRatesData={eventDetails?.groupRatesData}
                />
              </Accordion>
            )
        )}
      </div>
    </StyledEventTracking>
  ) : null;
};
